import { Navigate } from 'react-router-dom';
import type { ReactNode } from 'react';
import { getSession } from '../../platform/auth/session';

/**
 * Em produção, só entra com sessão Phoenix + casa escolhida.
 * Em desenvolvimento sem sessão, o DevAuthAdapter cobre (headers dev do client).
 */
export function RequireSession({ children }: { children: ReactNode }) {
  const session = getSession();
  const authorized = session ? Boolean(session.houseId) : import.meta.env.DEV;
  if (!authorized) {
    return <Navigate to="/login" replace />;
  }
  return <>{children}</>;
}
